export function offerResponse(p: any): string {
  if (p.response === 'undeliverable') return (p.delivered || p.delivery_status) === 'failed'
    ? 'Offer closed after a delivery failure'
    : 'Offer closed before delivery was confirmed';
  return p.response ? String(p.response).replace(/_/g, ' ') : '—';
}
export function offerDelivery(p: any): string {
  const status = p.delivered || p.delivery_status;
  if (status === 'failed') return 'Failed — WhatsApp reported a delivery failure';
  if (status === 'read') return 'Read — WhatsApp confirmed the message was opened';
  if (status === 'delivered') return 'Delivered — WhatsApp confirmed arrival on the provider’s device';
  if (status === 'sent') return p.response === 'undeliverable'
    ? 'Sent — WhatsApp accepted it, but delivery was not confirmed before the offer closed'
    : 'Sent — WhatsApp accepted it; arrival on the provider’s device is not confirmed';
  if (status === 'queued') return 'Queued — waiting to send to WhatsApp';
  if (status === 'suppressed') return 'Not sent — the offer was stopped before sending';
  return 'Delivery record missing — cannot confirm whether this provider was messaged';
}

export function offerDeliveryFailure(p: any): string | null {
  if ((p.delivered || p.delivery_status) !== 'failed') return null;
  const reason = typeof p.delivery_error === 'string' && p.delivery_error.trim();
  const code = p.delivery_error_code;
  return `${reason ? `Recorded reason: ${reason}` : 'No failure reason is recorded.'}${code ? ` (WhatsApp error ${code})` : ''}${Number(code) === 131026 ? ' This error alone does not confirm that the number is not on WhatsApp.' : ''}`;
}

export function conversationDelivery(delivery: any): string {
  if (delivery.status === 'manual_sending' || delivery.status === 'manual_unconfirmed')
    return 'Sending not confirmed — check before resending to avoid a duplicate';
  if (delivery.status === 'manual_failed') return `WhatsApp rejected the message — ${delivery.error || 'see sending error'}`;
  if (['error', 'dead_letter', 'failed'].includes(delivery.status))
    return 'Send failed — the sending attempt recorded an error';
  if (delivery.channel === 'web' || delivery.channel === 'mobile')
    return delivery.delivered_at ? 'Fetched by website/app — display and reading are not confirmed'
      : 'Waiting for website/app to fetch the message';
  if (delivery.send_confirmed_at)
    return 'Sent — WhatsApp accepted it; delivery and reading are not tracked in this panel';
  if (delivery.status === 'queued') return 'Queued — waiting to send to WhatsApp';
  return 'Send confirmation missing — this panel cannot confirm whether WhatsApp accepted the message';
}
